import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { menuSVG } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/nav';
import useUser from '../hooks/useUser';
import { getGlobalData, getNavbarItems, getMenu } from '../services/Contentful';
import PaymentMethods from '../services/Payment';
import AppContext from '../components/App/AppContext';

const menuItem = {
  title: 'Menú',
  icon: {
    url: menuSVG,
  },
  url: '',
};

const GlobalDataContext = createContext();

const GlobalDataProvider = ({ children }) => {
  const [globalData, setGlobalData] = useState(null);
  const [navbarData, setNavbarData] = useState(null);
  const [menuData, setMenuData] = useState(null);
  const [kushkiCards, setKushkiCards] = useState(null);
  const [loadingKushkiCards, setLoadingKushkiCards] = useState(true);
  const loading =
    globalData === null ||
    navbarData === null ||
    menuData === null ||
    loadingKushkiCards;
  const user = useUser();

  const { hasKushkiCards } = useContext(AppContext);

  useEffect(() => {
    if (user && globalData === null) {
      getGlobalData()
        .then(([{ data }]) => {
          setGlobalData(data);
        })
        .catch(() => setGlobalData({}));
    }

    if (user && navbarData === null) {
      getNavbarItems()
        .then(([navbarItemsResponse]) => {
          setNavbarData([...navbarItemsResponse.navbarItems, menuItem]);
        })
        .catch(() => {
          setNavbarData([menuItem]);
        });
    }

    if (user) {
      PaymentMethods.getPaymentMethod()
        .then(() => setKushkiCards(true))
        .catch(() => setKushkiCards(false))
        .finally(() => setLoadingKushkiCards(false));
    }
  }, [user]);

  useEffect(() => {
    if (
      user &&
      kushkiCards !== null &&
      menuData === null &&
      globalData !== null
    ) {
      const { isEnabled = { wompay: false } } = globalData;

      const isWompayEnabled = isEnabled?.wompay;
      getMenu(isWompayEnabled, hasKushkiCards)
        .then(([{ items }]) => {
          setMenuData(items);
        })
        .catch(() => {
          setMenuData(null);
        });
    }
  }, [user, menuData, kushkiCards]);

  return (
    <GlobalDataContext.Provider
      value={{ ...globalData, navbarData, loading, menuData }}
    >
      {children}
    </GlobalDataContext.Provider>
  );
};

GlobalDataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const useGlobalData = () => useContext(GlobalDataContext);

export { useGlobalData, GlobalDataProvider };
